import React, { Component } from 'react';
import {
  ButtonGroup,
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody } from 'reactstrap';

class ContactModal extends Component {
  state = {
    activeTab: 'phone'
  }

  handleActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  }

  Phone = () => {
    return (
      <ModalBody className="d-flex align-items-center justify-content-center flex-column text-center overflow-hidden" style={{ minHeight: '352px' }}>
        <img src="/icons/phone.svg" alt="Call Us" className="mb-3" />
        <h5>Call Us Toll-Free</h5>
        <h2 className="text-primary mb-3">(800) 994-6177</h2>
        <p><strong>Monday through Friday</strong><br />
        8:00am to 5:00pm (PST)</p>
      </ModalBody>
    );
  }

  Email = () => {
    return (
      <ModalBody className="pt-0 overflow-hidden" style={{ minHeight: '352px' }}>
        <p>Please describe issue in as much detail as possible including dates, amounts, and loan specifics. DO NOT include personal information like Social Security Number. It is not needed to identify you.</p>
        <FormGroup>
          <Label for="subject">I Want To Talk About</Label>
          <Input
            type="select"
            name="subject"
            id="subject"
          >
            <option value="">Select One...</option>
            <option value="subject1">Payment Issues</option>
            <option value="subject2">Change of Address</option>
            <option value="subject3">Other</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label for="emailBody">Your Message</Label>
          <Input type="textarea" name="email-body" id="emailBody" />
        </FormGroup>
        <Button color="primary" className="mt-1 w-100">Submit</Button>
      </ModalBody>
    );
  }

  Mail = () => {
    return (
      <ModalBody className="d-flex align-items-center justify-content-center flex-column text-center overflow-hidden" style={{ minHeight: '352px' }}>
        <img src="/icons/email.svg" alt="Mail Us" className="mb-3" />
        <h5 className="mb-3">Please send all payment checks and mail inquiries to:</h5>
        <p><strong>LendingUSA</strong><br/>
        Customer Relations<br/>
        PO Box 1234<br/>
        Sherman Oaks, CA 91403</p>
      </ModalBody>
    );
  }

  render() {
    const { activeTab } = this.state;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="md" className="overflow-hidden">

        <ModalHeader className="no-border" toggle={this.props.toggle}>Contact Us</ModalHeader>
        <ButtonGroup size="sm" className="d-flex ml-3 mr-3 mb-3">
          <Button color="primary" onClick={() => this.handleActiveTab('phone')} active={activeTab === 'phone' && true}>By Phone</Button>
          <Button color="primary" onClick={() => this.handleActiveTab('email')} active={activeTab === 'email' && true}>By Email</Button>
          <Button color="primary" onClick={() => this.handleActiveTab('mail')} active={activeTab === 'mail' && true}>By Mail</Button>
        </ButtonGroup>

        { activeTab === 'phone' && this.Phone() }
        { activeTab === 'email' && this.Email() }
        { activeTab === 'mail' && this.Mail() }


      </Modal>
    );
  }
}

export default ContactModal;
